import { DxfViewer } from "dxf-viewer";

export class CustomDxfViewer extends DxfViewer {
  constructor() {
    const element = document.createElement('div');
    document.body.appendChild(element);
    super(element, null);
    element.style.display = 'none';
  }

  toDataURL(type = 'image/jpeg', quality = 0.92) {
    const renderer = this.GetRenderer();
    if (!renderer) {
      console.log('Renderer is not initialized.');
      return;
    }

    // Render the scene.
    renderer.render(this.GetScene(), this.GetCamera());

    // Get the canvas element from the renderer.
    const canvas = this.GetCanvas();

    // Convert the canvas image to a data URL.
    return canvas.toDataURL(type, quality);
  }
}